import React from "react";
import {
  Tabs as ChakraTabs,
  Tab as ChakraTab,
  TabList,
  Stack,
} from "@chakra-ui/react";

export function Tabs({
  tabs,
  onChange,
  ...props
}: {
  tabs: { name: string; value: string }[];
  onChange?: (x: string) => void;
  [propName: string]: any;
}) {
  return (
    <ChakraTabs w="auto" border="none" colorScheme="black" {...props}>
      <TabList border="none">
        <Stack direction="row" spacing={3}>
          {tabs.map((tab) => (
            <ChakraTab
              key={tab.name}
              fontWeight="500"
              color="gray.500"
              fontSize="14px"
              px="2"
              onClick={() => onChange?.(tab.value)}
              textTransform="capitalize"
              _selected={{
                color: "#000",
                borderBottom: "2px solid black",
                boxShadow: "none",
              }}
            >
              {tab.name}
            </ChakraTab>
          ))}
        </Stack>
      </TabList>
    </ChakraTabs>
  );
}

export function Tab({
  children,
  ...props
}: {
  children: React.ReactNode;
  [propName: string]: any;
}) {
  return (
    <ChakraTab
      fontWeight="500"
      color="gray.500"
      fontSize="14px"
      px="2"
      background="red"
      _selected={{
        color: "#000",
        borderBottom: "2px solid black",
        boxShadow: "none",
      }}
    >
      {children}
    </ChakraTab>
  );
}
